import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15">
    <path d="M13.5 0h-12C.7 0 0 .7 0 1.5V15l3-3h10.5c.8 0 1.5-.7 1.5-1.5v-9c0-.8-.7-1.5-1.5-1.5z" />
  </svg>
);



// WEBPACK FOOTER //
// ./src/javascripts/svg/bubble.es6.js